import axios from 'axios';
import { API } from '../../index';

/**
 * Fetches and returns single user data
 *
 * @param {number} id - ID of the user
 */
export const fetchUserData = id => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        const store = getState();

        return axios
            .get(API + 'user/' + id, {
                headers: {
                    Authorization: store.auth.token,
                },
            })
            .then(success => {
                return resolve(success.data);
            })
            .catch(error => {
                console.error('Could not fetch user data: ', error);
                return reject(error);
            });
    });
};

/**
 * Sends PATCH request to /user API
 *
 * @param {number | null} id - ID of the user
 * @param {string} name - Full name
 * @param {string} email - Email address
 * @param {number} typeId - ID of the user type (1 = Admin, 2 = Reports Portal)
 * @param {number[]} allowedReports - IDs of the reports allowed to be created
 * @param {boolean} isActive - if user is enabled or disabled
 * @param {boolean} generatePassword - if user password should be generated and sent via email
 */
export const updateOrCreateUser = (id = null, name, email, typeId, allowedReports, isActive, generatePassword) => (
    dispatch,
    getState
) => {
    return new Promise((resolve, reject) => {
        const store = getState();

        const allowedReportsFormatted =
            allowedReports && typeof allowedReports.length !== 'undefined' && allowedReports.length > 0
                ? allowedReports.join(',')
                : '';

        return id
            ? axios
                  .patch(
                      API + 'user/' + id,
                      {
                          name,
                          email,
                          typeId,
                          allowedReports: allowedReportsFormatted,
                          generatePassword,
                          status: isActive ? 1 : 0,
                      },
                      {
                          headers: {
                              Authorization: store.auth.token,
                          },
                      }
                  )
                  .then(success => {
                      return resolve(success);
                  })
                  .catch(error => {
                      console.error('Could not update user', error);
                      return reject(error);
                  })
            : axios
                  .post(
                      API + 'user',
                      {
                          name,
                          email,
                          typeId,
                          allowedReports: allowedReportsFormatted,
                          generatePassword,
                          status: isActive ? 1 : 0,
                      },
                      {
                          headers: {
                              Authorization: store.auth.token,
                          },
                      }
                  )
                  .then(success => {
                      return resolve(success);
                  })
                  .catch(error => {
                      console.error('Could not create user', error);
                      return reject(error);
                  });
    });
};



// WEBPACK FOOTER //
// ./app/web/src/container/AdminUserForm/action.js